<template>
  <div class="box">
    <div class="p-5 border-b border-gray-200 dark:border-dark-5">
      <h2 class="font-medium text-base">{{ $t('text.financeInformation') }}</h2>
    </div>
    <div class="p-5">
      <InputSelect
        :label="$t('text.haveAnotherLoan')"
        :options="yesOrNo"
        value-key="id"
        v-model.number="form.isLoan"
      />
      <InputSelect
        :label="$t('text.monthlyLoanAmount')"
        :options="loanRange"
        v-model="form.leasingPaymentMonth"
        no-label
      />
      <InputSelect
        :label="$t('text.haveCar')"
        :options="yesOrNo"
        value-key="id"
        v-model.number="form.isCar"
      />
      <InputSelect
        :label="$t('text.monthlyIncome')"
        :options="salaryRange"
        v-model="vForm.monthlySalary.$model"
        :vuelidate="vForm.monthlySalary"
        no-label
      />
      <InputSelect
        :label="$t('text.currentIndustry')"
        :options="jobTypes"
        value-key="id"
        v-model.number="vForm.jobTypeId.$model"
        :vuelidate="vForm.jobTypeId"
      />
      <InputString :label="$t('text.totalYearsWorked')" v-model.number="form.totalYearWork" />
      <InputString
        :label="$t('text.nameOfCurrentOrganization')"
        v-model.trim="vForm.companyName.$model"
        :vuelidate="vForm.companyName"
      />
      <InputString
        :label="$t('text.totalYearsWorkedCurrentOrganization')"
        v-model.number="form.totalYearWorkingCompany"
      />
      <InputSelect
        :label="$t('text.currentWorkPosition')"
        :options="jobPositions"
        value-key="id"
        v-model.number="vForm.positionTypeId.$model"
        :vuelidate="vForm.positionTypeId"
      />
    </div>
  </div>
</template>

<script>
import InputString from '@/components/ui/input/InputString';
import InputSelect from '@/components/ui/input/InputSelect';

export default {
  props: {
    form: Object,
    vForm: Object,
    jobTypes: Array,
    jobPositions: Array,
    salaryRange: Array,
    loanRange: Array,
  },

  components: {
    InputString,
    InputSelect,
  },

  data() {
    return {
      yesOrNo: [
        {
          id: 0,
          name: this.$t('text.no'),
        },
        {
          id: 1,
          name: this.$t('text.yes'),
        },
      ],
    };
  },
};
</script>
